import { IAbsenceWarningRepository } from 'shared/domain/repositories';
import { makeHTTPProvider } from 'shared/infra/providers';

import VectisAbsenceWarningRepository from './implementations/VectisAbsenceWarningRepository';

let instance: IAbsenceWarningRepository | null = null;

export default function makeAbsenceWarningRepository() {
  if (!instance) {
    const httpProvider = makeHTTPProvider();

    instance = new VectisAbsenceWarningRepository(httpProvider);
  }

  return instance;
}
